// #525 — which UI language a browser language tag selects.
//
// `navigator.language` is a BCP 47 tag ("fr-FR", "en-GB", "de"). Only the
// primary subtag decides: "fr-CA" is French, "en-US" is English, anything not
// in the supported list gets the fallback. Pure, so the rule is testable
// without a browser.

export function resolveLocale(
  tag: string | null | undefined,
  supported: readonly string[],
  fallback: string
): string {
  const primary = (tag ?? '').trim().toLowerCase().split(/[-_]/)[0];
  return primary && supported.includes(primary) ? primary : fallback;
}

/** The next language in the supported list after `current`, wrapping. */
export function nextLocale(current: string, supported: readonly string[]): string {
  const index = supported.indexOf(current);
  return supported[(index + 1) % supported.length] ?? supported[0];
}
